import { render, staticRenderFns } from "./AddDrawing.vue?vue&type=template&id=0fd879b1&scoped=true"
import script from "./AddDrawing.vue?vue&type=script&lang=js"
export * from "./AddDrawing.vue?vue&type=script&lang=js"
import style0 from "./AddDrawing.vue?vue&type=style&index=0&id=0fd879b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd879b1",
  null
  
)

export default component.exports